(() => {
  const age = document.getElementById('age');
  if (age) {
    const KEY = 'ma_age_ok';
    let ok = false;
    try { ok = Number(localStorage.getItem(KEY)) > Date.now(); } catch (e) {}
    if (!ok) {
      age.hidden = false;
      document.getElementById('age-yes').addEventListener('click', () => {
        try { localStorage.setItem(KEY, String(Date.now() + 30 * 864e5)); } catch (e) {}
        age.classList.add('leaving');
        setTimeout(() => (age.hidden = true), 800);
      });
      document.getElementById('age-no').addEventListener('click', () => {
        document.getElementById('age-msg').textContent = 'Ce site est réservé aux personnes majeures.';
      });
    }
  }
  document.querySelectorAll('[data-pearls]').forEach((field) => {
    for (let i = 0; i < 38; i++) {
      const r = Math.sqrt(Math.random()) * 38, t = Math.random() * Math.PI * 2;
      const s = 14 + Math.random() * 20;
      const p = document.createElement('span');
      p.className = 'pearl';
      p.style.width = p.style.height = s + 'px';
      p.style.left = `calc(${50 + r * Math.cos(t)}% - ${s / 2}px)`;
      p.style.top = `calc(${50 + r * Math.sin(t)}% - ${s / 2}px)`;
      field.appendChild(p);
    }
  });
  const msg = document.querySelector('#ouverture .notify-msg');
  if (msg && msg.textContent.trim()) document.getElementById('ouverture').scrollIntoView();
})();
